import { c as _c } from "react/compiler-runtime";
import { ColorBlock } from "@repo/ui/color-block";
import { cn } from "@repo/ui/utils";
import { stegaClean } from "next-sanity";
import { isDarkBackground, resolveBrandColour } from "@/lib/color-utils";
import { MarketingPopupClose } from "./marketing-popup-close.component";
import { MarketingPopupContent } from "./marketing-popup-content.component";
import type { MarketingPopupVariantProps } from "./marketing-popup.types";
export function MarketingPopupColourBlock(t0) {
  const $ = _c(18);
  const {
    popup,
    className,
    onClose,
    onCtaClick
  } = t0;
  let resolvedColour;
  let t1;
  if ($[0] !== className || $[1] !== popup.colour) {
    resolvedColour = resolveBrandColour(stegaClean(popup.colour), "light-green");
    const isDark = isDarkBackground(resolvedColour);
    t1 = cn("relative w-full max-w-2xl overflow-hidden rounded-md", isDark && "dark", className);
    $[0] = className;
    $[1] = popup.colour;
    $[2] = resolvedColour;
    $[3] = t1;
  } else {
    resolvedColour = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onClose) {
    t2 = <MarketingPopupClose onClick={onClose} />;
    $[4] = onClose;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onCtaClick || $[7] !== popup) {
    t3 = <MarketingPopupContent popup={popup} onCtaClick={onCtaClick} headlineClassName="typography-mobile-heading-h3-voyage tablet:typography-desktop-heading-h3-voyage max-w-[18ch]" />;
    $[6] = onCtaClick;
    $[7] = popup;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="relative w-full p-6 tablet:p-12">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== resolvedColour || $[13] !== t4) {
    t5 = <ColorBlock variant="square" color={resolvedColour} className="flex">{t4}</ColorBlock>;
    $[12] = resolvedColour;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t5) {
    t6 = <article className={t1} data-testid="marketing-popup-colour-block">{t5}</article>;
    $[15] = t1;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}